"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
window['$'] = window['jQuery'] = $;
require("jqueryui");
//# sourceMappingURL=import-queryui.js.map